import config from "./internalProd";

const conf = {
  ...config,
  env: "qa",
};

export default conf;
